import * as Yup from 'yup';

export const skillSetFormSchema = Yup.object().shape({
    skillsetName: Yup.string().required('Name is required'),
});
